'use strict'

import {getLoadingContainer, removeLoadingContainer} from "../../../scripts/loading";
import asyncAppend from "../../../libs/@elements/async-append";
import {isParsleyForm, isValid, whenValid} from "../../../libs/@elements/parsley-bootstrap-validation";
import fetch from '../../../libs/@elements/fetch';
import formDataEntries from "form-data-entries";

let
    maxLength = Number.parseFloat(_config['trackMax'] ? _config['trackMax'] : 15000),
    customMin = Number.parseFloat(_config['customCutMin'] ? _config['customCutMin'] : 200),
    customMax = Number.parseFloat(_config['customCutMax'] ? _config['customCutMax'] : 3000),
    $container, trackType, warnLength = Math.round((maxLength * 2) / 3);

export function init() {
    $container = $('.js-strex-track__result');
}

export function initInScope($scope) {

    const
        $step1 = $scope.find('.js-strex-track__configure-tracks'),
        $step2 = $scope.find('.js-strex-track__choose-power-supply'),
        $step3 = $scope.find('.js-strex-track__setup-track');

    if($step1.length){
        initSubStep1($step1);
    }
    if($step2.length){
        initSubStep2($step2);
    }
    if($step3.length){
        initSubStep3($step3.eq(0));
    }
}

function loadSubStep(url, additionalFormData = {}) {
    const
        formData    = new URLSearchParams(formDataEntries($container.find('form')[0]));

    for (const [key, value] of Object.entries(additionalFormData)) {
        formData.append(key, value)
    }

    const
        request = fetch(url, {
            body: formData
        });

    asyncAppend({
        $target: $container,
        $loading: $(getLoadingContainer()).appendTo($container)
    }, request);

    request.finally(() => {
        removeLoadingContainer($container)
    })

    return request;
}

function initSubStep1($scope) {
    const $form = $scope;

    $form.on('submit', (e) => {
        e.preventDefault();
        const
            url = $form.attr('action'),
            additionalParams = {};

        if($(document.activeElement).attr('name'))
            additionalParams[$(document.activeElement).attr('name')] = $(document.activeElement).val();
        else
            additionalParams[e.originalEvent.submitter.name] = e.originalEvent.submitter.value;

        loadSubStep(url, additionalParams)
    })
}

function initSubStep2($scope) {
    const
        $form       = $scope.find('.js-strex-track__power-form'),
        $goBackBtn  = $scope.find('.js-strex-track__back'),
        $powerRadio = $scope.find('.js-strex-track__power-input');

    $goBackBtn.on('click', (e) => {
        e.preventDefault();
        loadSubStep(e.currentTarget.getAttribute('href'))
    })

    $powerRadio.on('change', () => {
        loadSubStep($form.attr('action'))
    })

    $form.on('submit', (e) => {
        e.preventDefault();
        loadSubStep($form.attr('action'));
    })
}


function initSubStep3($scope) {
    const
        $form               = $scope.find('.js-strex-track__step-form'),
        $goBackBtn          = $scope.find('.js-strex-track__back'),
        tracks              = {},
        $customModal        = $('.js-modal--strex-add-length'),
        $trackBtns          = $scope.find('.js-strex-track__add-btn'),
        $addTrackBtns       = $scope.find('.js-strex-track__placeholder'),
        $listContainer      = $scope.find('.js-strex-track__result'),
        $tabs               = $scope.find('.js-strex-track__tab'),
        isSquare            = $scope.data('shape') === 'square' ? 2 : 1;

    trackType = $scope.data('shape');

    $goBackBtn.on('click', (e) => {
        e.preventDefault();
        loadSubStep(e.currentTarget.getAttribute('href'))
    })

    let isTransition = false;
    $addTrackBtns.on('click', () => {
        if(isTransition){
            return
        }
        isTransition = true;
        $trackBtns.addClass('flash').on('webkitTransitionEnd oTransitionend msTransitionEnd Transitionend', () => {
            $trackBtns.removeClass('flash').off('webkitTransitionEnd oTransitionend msTransitionEnd Transitionend');
            isTransition = false;
        })
    })

    function lengthProviderService(){
        const $totalLength = $scope.find('.js-strex-track__total');
        let totalLength = 0;

        function addLength(length) {
            totalLength += length;
            $totalLength.text(totalLength);

            checkLengths();
        }

        function addTrackLength(length) {
            totalLength += (length * isSquare);
            $totalLength.text(totalLength);

            checkLengths();
        }

        function removeLength(length) {
            totalLength -= length;
            $totalLength.text(totalLength);

            checkLengths();
        }

        function removeTrackLength(length) {
            totalLength -= (length * isSquare);
            $totalLength.text(totalLength);

            checkLengths();
        }

        function checkLengths() {
            const
                $smallBtn       = $scope.find('button[data-length="1000"]'),
                $middleBtn      = $scope.find('button[data-length="2000"]'),
                $largeBtn       = $scope.find('button[data-length="3000"]'),
                $placeholders   = $scope.find('.js-strex-track__placeholder'),
                $customBtn      = $scope.find('button[data-toggle="modal"]'),

                bigBtnLimit     = trackType === 'square' ? 6000 : 3000,
                midBtnLimit     = trackType === 'square' ? 4000 : 2000,
                smallBtnLimit   = trackType === 'square' ? 2000 : 1000,
                customBtnLimit  = trackType === 'square' ? customMin * 2 : customMin;

            if(totalLength > maxLength - bigBtnLimit){
                $largeBtn.prop('disabled', true);
                if(totalLength > maxLength - midBtnLimit){
                    $middleBtn.prop('disabled', true);
                    if(totalLength > maxLength - smallBtnLimit){
                        $smallBtn.prop('disabled', true);
                        if(totalLength > maxLength - customBtnLimit){
                            $customBtn.prop('disabled', true);
                            $placeholders.hide();
                        }else{
                            $customBtn.prop('disabled', false);
                            $placeholders.show();
                        }
                    }else{
                        $smallBtn.prop('disabled', false);
                        $customBtn.prop('disabled', false);
                        $placeholders.show();
                    }
                }else{
                    $middleBtn.prop('disabled', false);
                    $smallBtn.prop('disabled', false);
                    $customBtn.prop('disabled', false);
                    $placeholders.show();
                }
            }else{
                $largeBtn.prop('disabled', false);
                $middleBtn.prop('disabled', false);
                $smallBtn.prop('disabled', false);
                $customBtn.prop('disabled', false);
                $placeholders.show();
            }

            $totalLength.removeClass('text-warning');
            $totalLength.removeClass('text-danger');

            if(totalLength > warnLength){
                if(totalLength > maxLength) {
                    $totalLength.addClass('text-danger');
                }else{
                    $totalLength.addClass('text-warning');
                }
            }else{
                $totalLength.removeClass('text-warning');
                $totalLength.removeClass('text-danger');
            }
        }

        function checkLength(length) {
            if(totalLength + length  > maxLength){
                return false
            }
            return true;
        }

        function getLength() {
            return totalLength
        }

        return{
            addLength : addLength,
            addTrackLength : addTrackLength,
            removeTrackLength : removeTrackLength,
            removeLength : removeLength,
            checkLength : checkLength,
            getLength : getLength
        }
    }

    const lengthProvider = new lengthProviderService();

    $tabs.each((i, track) => {
        const $track = $(track);
        track.track = new Track($track, Object.keys(tracks).length, lengthProvider);
        $track.on('update', () => {
            updateList()
        });
        tracks[String.fromCharCode(i + 65).toUpperCase()] = track.track;
    });


    const updateListURL = $form.data('list-url');
    let pendingRequest = null;
    function updateList(){
        if(pendingRequest){
            pendingRequest.abort();
        }

        let formData = new URLSearchParams(formDataEntries($container.find('form')[0]))

        pendingRequest = fetch(updateListURL,{
            body: formData
        });

        pendingRequest.catch((error, requestState) => {
            if ((!error || error.name !== 'AbortError') // native fetch abort
                && requestState !== 'abort') { // jquery abort
                // pendingRequest = null;
            }
        });

        asyncAppend({
            $target: $listContainer,
            $loading: $(getLoadingContainer()).appendTo($listContainer)
        }, pendingRequest);

        pendingRequest.finally(() => {
            removeLoadingContainer($listContainer);
            pendingRequest = null;
        })
    }

    $customModal.on('show.bs.modal', function (e) {
        const
            trackId         = $(e.relatedTarget).data('track'),
            Track           = tracks[trackId],
            $input          = $customModal.find('input'),
            lengthAvailable = maxLength - lengthProvider.getLength(),
            maxCalcLength   = lengthAvailable > customMax ? customMax : lengthAvailable,
            $customLengthForm= $customModal.find('.js-strex-track__custom-length-form');

        const maxInputLength  = trackType === 'square'
            ? (maxCalcLength * 2 <= lengthAvailable ? maxCalcLength : lengthAvailable / 2)
            : maxCalcLength;

        $input.val(null);
        $input.attr('min', customMin);
        $input.attr('max', maxInputLength);
        $input.attr('placeholder', customMin + " - " + maxInputLength);

        whenValid($customLengthForm);

        $customLengthForm.off('submit').on('submit', (e) => {
            e.preventDefault();

            if (isParsleyForm($customLengthForm) && !isValid($customLengthForm)) {
                return;
            }

            Track.addItem(Number.parseInt($input.val()))
            $customModal.modal('hide');
        })
    })

    $customModal.on('shown.bs.modal', () => {
        $customModal.find('input').focus();
    })

}

class Track {
    constructor($scope, trackId, lengthProvider){
        this.$scope = $scope;
        this.trackId = String.fromCharCode(trackId + 65).toUpperCase();
        this.length = 0;
        this.$length = $('.js-strex-track__length-' + this.trackId);
        this.items = {};
        this.$track = $scope.find('.js-strex-track__track');
        this.$addTrackBtn =  $scope.find('.js-strex-track__add');
        this.lengthProvider = lengthProvider;
        this.$powerBtn = $scope.find('.js-strex-track__power-input');
        this.$connectors = $scope.find('.js-strex-track__connector');
        this.powerIsActivePowerBtn = false;
        this.connectorLength = 0;

        this.bindlisteners();

        this.$connectors.each((_, el) => {
            this.connectorLength += Number.parseFloat(el.getAttribute('data-length'));
            this.addLength(Number.parseFloat(el.getAttribute('data-length')));
        })

        $scope.find('.js-strex-track__track-item').each((_, track) => {
            const $track = $(track)
            this.initItem($track)
        })
    }

    bindlisteners(){
        this.$addTrackBtn.on('click', (e) => {
            const
                $target         = $(e.currentTarget),
                length          = $target.data('length');

            this.addItem(length);
        })

        if(this.$powerBtn){
            //set initial value
            const
                $checkbox       = $('.js-strex-track__power-input:checked'),
                $btnContainer   = this.$powerBtn.closest('.js-strex-track__power-container'),
                $endCap         = $btnContainer.find('.js-strex-track__endcap');

            if($('.js-strex-track__power-input:checked').data('track-id') === this.trackId){
                $('.js-strex-track__power-input:checked').closest('.js-strex-track__power-container').find('.js-strex-track__endcap').hide();
                this.addLength(Number.parseFloat($checkbox.data('length')));
                this.powerIsActivePowerBtn = true;
            }else{
                this.powerIsActivePowerBtn = false;
            }

            $endCap.each((_, cap) => {
                if ($(cap).css('display') !== 'none'){
                    this.addLength(Number.parseFloat($(cap).data('length')));
                }
            })

            $('.js-strex-track__power-input').on('change', (e) =>{
                const
                    $checkbox       = $(e.target),
                    $btnContainer   = $checkbox.closest('.js-strex-track__power-container'),
                    $endCap         = $btnContainer.find('.js-strex-track__endcap');

                this.$powerBtn.each((_, btn) => {
                    const
                        $checkbox       = $(btn),
                        $btnContainer   = $checkbox.closest('.js-strex-track__power-container'),
                        $endCap         = $btnContainer.find('.js-strex-track__endcap');
                    this.addLength(Number.parseFloat($endCap.data('length')))
                    $endCap.show();
                })

                if($('.js-strex-track__power-input:checked').data('track-id') === this.trackId){
                    $endCap.hide();
                    this.removeLength(Number.parseFloat($endCap.data('length')))
                    this.removeLength(Number.parseFloat($endCap.data('length')))
                    if(trackType !== 'line'){
                        this.addLength(Number.parseFloat($checkbox.data('length')))
                    }
                    this.powerIsActivePowerBtn = true;
                    this.$scope.trigger('update');
                }else{
                    if(this.powerIsActivePowerBtn){
                        this.removeLength(Number.parseFloat($checkbox.data('length')))
                        this.powerIsActivePowerBtn = false;
                    }
                }
            })
        }
    }

    initItem($item){
        const
            id      = Number.parseInt($item.attr('id')),
            length  = Number.parseInt($item.find('.js-strex-track__track-item-input').val());

        this.items[id] = $item;

        $item.on('mouseenter', () => {
            $item.addClass('active');
        })
        $item.on('mouseleave', () => {
            $item.removeClass('active');
        })

        this.addTrackLength(length);

        if(length < 1000){
            $item.addClass('strex-track__track-item--medium')
            $item.find('.strex-track__track-remove span').remove()
        }

        $item.find('.js-strex-track__track-remove').on('click', () =>  this.removeItem(id));
        $item.find('.js-strex-track__tack-item-arrow-left').on('click', () =>  this.moveItem(id, id - 1));
        $item.find('.js-strex-track__tack-item-arrow-right').on('click', () =>  this.moveItem(id, id + 1));
    }


    addItem(length){
        const
            trackTemplate   = $($('.js-strex-track__template').clone().html()),
            id              = Object.keys(this.items).length,
            name            = this.trackId + "[" + id + "]";

        trackTemplate.attr('id', id);
        trackTemplate.css('width', (length / 10) * 2);
        trackTemplate.find('.js-strex-track__track-item-label').html(length + ( length >= 1000 ? ' mm' : ''));
        trackTemplate.find('.js-strex-track__track-item-input').attr('name', name);
        trackTemplate.find('.js-strex-track__track-item-input').attr('value', length);
        trackTemplate.find('.js-strex-track__track-remove').on('click', () =>  this.removeItem(id));
        trackTemplate.find('.js-strex-track__tack-item-arrow-left').on('click', () =>  this.moveItem(id, id - 1));
        trackTemplate.find('.js-strex-track__tack-item-arrow-right').on('click', () =>  this.moveItem(id, id + 1));

        this.items[id] = trackTemplate;
        this.$track.append(trackTemplate);

        trackTemplate.on('mouseenter', () => {
            trackTemplate.addClass('active');
        })
        trackTemplate.on('mouseleave', () => {
            trackTemplate.removeClass('active');
        })

        this.addTrackLength(length);

        if(length < 1000){
            trackTemplate.addClass('strex-track__track-item--medium')
            trackTemplate.find('.strex-track__track-remove span').remove()
        }

        this.$scope.find(".strex-track__overview").animate({
            scrollLeft: this.$scope.find(".strex-track__overview-scroller").width()
        }, 300);

        this.$scope.trigger('update');
    }

    moveItem(id, index){
        const
            length  = Object.keys(this.items).length;

        if(id === index || index === length || id < 0) {
            return;

        }

        const
            $item   = this.$track.find('#' + id),
            $Olditem= this.$track.find('#' + index);

        // const oldItems = Object.assign({}, this.items);

        if(id > index){
            $item.insertBefore($Olditem);

            for(let i = index; i < id; i++){
                const
                    newId   = i + 1,
                    $item   = this.$track.find('#' + i);
                $item.attr('id', newId);
                $item.find('.js-strex-track__track-item-input').attr('name', this.trackId + "[" + newId + "]");
                $item.find('.js-strex-track__track-remove').off('click').on('click', () =>  this.removeItem(newId));
                $item.find('.js-strex-track__tack-item-arrow-left').off('click').on('click', () =>  this.moveItem(newId, newId - 1));
                $item.find('.js-strex-track__tack-item-arrow-right').off('click').on('click', () =>  this.moveItem(newId, newId + 1));
                this.items[newId] = $item;
            }
        }else{
            $item.insertAfter($Olditem);

            for(let i = id + 1; i <= index; i++){
                const
                    newId   = i - 1,
                    $item   = this.$track.find('#' + i);
                $item.attr('id', newId);
                $item.find('.js-strex-track__track-item-input').attr('name', this.trackId + "[" + newId + "]");
                $item.find('.js-strex-track__track-remove').off('click').on('click', () =>  this.removeItem(newId));
                $item.find('.js-strex-track__tack-item-arrow-left').off('click').on('click', () =>  this.moveItem(newId, newId - 1));
                $item.find('.js-strex-track__tack-item-arrow-right').off('click').on('click', () =>  this.moveItem(newId, newId + 1));
                this.items[newId] = $item;
            }
        }

        this.items[index] = $item;
        $item.attr('id', index);
        $item.find('.js-strex-track__track-item-input').attr('name', this.trackId + "[" + index + "]");
        $item.find('.js-strex-track__track-remove').off('click').on('click', () =>  this.removeItem(index));
        $item.find('.js-strex-track__tack-item-arrow-left').off('click').on('click', () =>  this.moveItem(index, index - 1));
        $item.find('.js-strex-track__tack-item-arrow-right').off('click').on('click', () =>  this.moveItem(index, index + 1));

        this.$scope.trigger('update');
    }

    removeItem(id){
        const
            length  = Object.keys(this.items).length,
            $item   = this.$track.find('#' + id);

        this.removeTrackLength($item.find('input').val());
        $item.remove();

        if(id === length -1){
            delete this.items[id];
        }else{
            for(let i = id + 1; i < length; i++){
                const
                    $item   = this.$track.find('#' + i),
                    name    = this.trackId + "[" + (i - 1) + "]";

                this.items[i - 1] = this.items[i];
                $item.attr('id', i - 1);
                $item.find('.js-strex-track__track-item-input').attr('name', name);
                $item.find('.js-strex-track__track-remove').off('click').on('click', () =>  this.removeItem(i - 1));
                $item.find('.js-strex-track__tack-item-arrow-left').off('click').on('click', () =>  this.moveItem(i - 1, i - 2));
                $item.find('.js-strex-track__tack-item-arrow-right').off('click').on('click', () =>  this.moveItem(i - 1, i));
            }
            delete this.items[length - 1];
        }

        this.$scope.trigger('update');
    }

    addLength(length) {
        this.length += length;
        if(trackType === 'square'){
            this.$length.text(this.length - (this.connectorLength / 2));
        }else{
            this.$length.text(this.length);
        }
        this.lengthProvider.addLength(length)
    }

    addTrackLength(length) {
        this.length += length;
        if(trackType === 'square'){
            this.$length.text(this.length - (this.connectorLength / 2));
        }else{
            this.$length.text(this.length);
        }
        this.lengthProvider.addTrackLength(length)
    }

    removeLength(length){
        this.length -= length;
        if(trackType === 'square'){
            this.$length.text(this.length - (this.connectorLength / 2));
        }else{
            this.$length.text(this.length);
        }
        this.lengthProvider.removeLength(length)
    }
    removeTrackLength(length){
        this.length -= length;
        if(trackType === 'square'){
            this.$length.text(this.length - (this.connectorLength / 2));
        }else{
            this.$length.text(this.length);
        }
        this.lengthProvider.removeTrackLength(length)
    }
}